import { loadScript } from '../../utils/loadScript';

const ID = 'GooglePaySDK';

/**
 * @see https://developers.google.com/pay/api/web/guides/tutorial#js-load
 */
const SCRIPT_SRC = 'https://pay.google.com/gp/p/js/pay.js';

export const loadGooglePaySdk = (): Promise<void> => {
    if (window.google?.payments?.api?.PaymentsClient) {
        return Promise.resolve();
    }

    return loadScript(ID, SCRIPT_SRC, true);
};
